<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-show="editable&&popupParam.workMeasurementPlanId && !disabled"
                  label="삭제"
                  icon="remove"
                  @btnClicked="deleteData"/>
                <c-btn
                  v-show="editable&&!disabled"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="기본정보저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
                <c-btn
                  v-show="editable&&!disabled && updateMode"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="data"
                  mappingType="PUT"
                  label="완료"
                  icon="check"
                  @beforeAction="completeData"
                  @btnCallback="completeCallback" />
                <c-btn
                  v-show="editable && disabled"
                  label="작성중으로 변경"
                  icon="undo" 
                  @btnClicked="updateModeData" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="측정기관"
                  name="measPlaceName"
                  v-model="data.measPlaceName">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-datepicker
                  required
                  :editable="editable"
                  type="year"
                  :disabled="disabled || updateMode"
                  label="측정년도"
                  name="measYear"
                  v-model="data.measYear">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <!-- 분기 -->
                <c-select
                  required
                  type="edit"
                  :editable="editable"
                  codeGroupCd="WORK_MEAS_QUARTER_CD"
                  itemText="codeName"
                  :disabled="disabled || updateMode"
                  itemValue="code"
                  name="measQuarter"
                  label="분기"
                  v-model="data.measQuarter"
                ></c-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-datepicker
                  :editable="editable"
                  type="date"
                  :disabled="disabled"
                  label="측정일"
                  :range="true"
                  name="measPeriod"
                  v-model="measPeriod">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="측정계획명"
                  name="measPlanContent"
                  v-model="data.measPlanContent">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="editable"
                  :disabled="disabled"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  suffix="℃"
                  :editable="editable"
                  label="작업장기온"
                  name="measTemperature"
                  v-model="data.measTemperature">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text
                  suffix="%"
                  :editable="editable"
                  label="작업장습도"
                  name="measHumidity"
                  v-model="data.measHumidity">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
      </div>
    </q-form>
    <c-tab
      class="q-mt-sm"
      type="tabcard"
      align="left"
      :tabItems.sync="tabItems"
      :inlineLabel="true"
      v-model="tab"
      @tabClick="tabClick"
    >
      <template v-slot:default="tab" >
        <component
          :is="tab.component"
          :data.sync="data"
          :disabled="disabled"
          :updateMode="updateMode"
          :tabParam="tabParam"
          :attachInfo.sync="attachInfo"
          @getDetail="getDetail"
        />
      </template>
    </c-tab>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import CDatepicker from '../../../components/CDatepicker.vue';
export default {
  components: { CDatepicker },
  name: 'work-measure-plan-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        workMeasurementPlanId: '',
      }),
    },
  },
  data() {
    return {
      mappingType: 'POST',
      saveUrl: transactionConfig.sai.workmeas.plan.insert.url,
      insertUrl: '',
      updateUrl: '',
      completeUrl: transactionConfig.sai.workmeas.plan.complete.url,
      deleteUrl: '',
      checkUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isComplete: false,
      data: {
        workMeasurementPlanId: '',
        plantCd: '',
        measPlaceName: '',
        measPlanContent: '',
        measQuarter: null,
        measYear: '',
        measStartDate: '',
        measEndDate: '',
        measCompleteFlag: 'N',
        measTemperature: '',
        measHumidity: '',
        regUserId: '',
        chgUserId: '',

        workMeasurementResultModelList: [],
        deleteList1: [], // 화학적 인자
        deleteList2: [], // 물리적 인자
        deleteList3: [], // 분진
      },
      measPeriod: ['', ''],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      measTime: [],
      updateMode: false,
      tab: 'resultInfo1',
      tabItems: [
        { name: 'resultInfo1', icon: 'groups', label: '화학적인자', component: () => import(`${'./workMeasureResultInfo.vue'}`) },
        { name: 'resultInfo2', icon: 'groups', label: '물리적인자', component: () => import(`${'./workMeasureResultInfo.vue'}`) },
        { name: 'resultInfo3', icon: 'groups', label: '분진', component: () => import(`${'./workMeasureResultInfo.vue'}`) },
        { name: 'attach', icon: 'attach_file', label: '첨부파일', component: () => import(`${'./workMeasureResultAttach.vue'}`) },
      ],
      tabParam: {
        title: '화학적인자',
        hazardClassFstCd: 'HCF0000005'
      },
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'WORK_MEASURE_RESULT',
        taskKey: '',
      }
    };
  },
  computed: {
    disabled() {
      return this.editable && this.data.measCompleteFlag === 'Y'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.workmeas.plan.get.url;
      this.checkUrl = selectConfig.sai.workmeas.plan.check.url;
      this.insertUrl = transactionConfig.sai.workmeas.plan.insert.url;
      this.updateUrl = transactionConfig.sai.workmeas.plan.update.url;
      this.deleteUrl = transactionConfig.sai.workmeas.plan.delete.url;
      this.completeUrl = transactionConfig.sai.workmeas.plan.complete.url;
      this.updateModeUrl = transactionConfig.sai.workmeas.plan.updateMode.url;
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.workMeasurementPlanId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.workMeasurementPlanId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          this.updateMode = true;
          if (_result.data.measStartDate && _result.data.measEndDate) {
            this.measPeriod = [this.data.measStartDate, this.data.measEndDate];
          }
          this.attachInfo.taskKey = this.popupParam.workMeasurementPlanId
        },);
      }
    },
    saveData() {
      if (this.popupParam.workMeasurementPlanId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;

              if(this.measPeriod) {
                this.data.measStartDate = this.measPeriod[0];
                this.data.measEndDate = this.measPeriod[1];
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          },);
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.workMeasurementPlanId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.workMeasurementPlanId = result.data
      this.$set(this.attachInfo, 'taskKey', result.data)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.getDetail();
    },
    completeData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;

              if(this.measPeriod) {
                this.data.measStartDate = this.measPeriod[0];
                this.data.measEndDate = this.measPeriod[1];
              }
              this.isComplete = !this.isComplete;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.workMeasurementPlanId = result.data
      this.getDetail();
    },
    tabClick(result) {
      if (result.name === 'resultInfo1') {
        this.tabParam.title = '화학적인자';
        this.tabParam.hazardClassFstCd = 'HCF0000005';
      } else if (result.name === 'resultInfo2') {
        this.tabParam.title = '물리적인자';
        this.tabParam.hazardClassFstCd = 'HCF0000001';
      } else {
        this.tabParam.title = '분진';
        this.tabParam.hazardClassFstCd = 'HCF0000010';
      }
    },
    updateModeData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '작성중 상태로 변경하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.updateModeUrl;
          this.$http.type = 'PUT';
          this.$http.param = this.data
          this.$http.request(() => {
            this.getDetail();
            window.getApp.$emit('APP_REQUEST_SUCCESS');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  },
};
</script>
